import http from './index'

export function login(password, captchaId, captchaCode) {
  return http.post('/auth/login', {
    password,
    captcha_id: captchaId,
    captcha_code: captchaCode
  })
}

export function logout() {
  return http.post('/auth/logout')
}
